import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { pollsLoaded, removePoll } from '../../actions';
import { feedbackActions } from '../../webapi';
import { checkLoggedIn, validateAccess } from '../../session';
import { Text } from '../../components/text';

class ListPoll extends Component {
  state = {
    polls: [],
    sortColumn: 'EndTime', // column to sort by
    sortDesc: true, // if true, sort descending rather than ascending
    now: moment.utc().valueOf(),
  };

  UNSAFE_componentWillMount() {
    checkLoggedIn(this, this.props.auth);
    this.updateProps(this.props);
  }

  componentDidMount() {
    this.getData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateProps(nextProps);
  }

  updateProps(props) {
    this.setState({
      polls: props.polls,
    });
  }

  getData() {
    feedbackActions.getPolls(this.props.auth.site).then((res) => {
      if (res.data != null && !_.isEmpty(res.data) && res.data[0].Site === this.props.auth.site) {
        this.props.pollsLoaded(res.data);
      }
    });
  }

  sortByCol(col) {
    if (this.state.sortColumn === col) {
      this.setState({
        sortDesc: !this.state.sortDesc,
      });
    } else {
      this.setState({
        sortColumn: col,
        sortDesc: false,
      });
    }
  }

  removePoll(poll) {
    if (window.confirm(`Are you sure you want to delete that survey? You will no longer be able to access this survey's responses.`)) {
      this.props.removePoll(poll.Id);
      feedbackActions
        .deletePoll(this.props.auth.site, poll.Id)
        .then((res) => {
          this.getData();
        })
        .catch((res) => {
          alert('Something went wrong with the request. Please try again.');
        });
    }
  }

  renderPoll(source) {
    return source.map((ev) => {
      if (ev != null) {
        return (
          <tr key={ev.Id}>
            <td className="table-TitleColumn">
              {validateAccess(this.props.auth.site, 'polls', this.props.auth) || ev.ShowResults ? (
                <Link to={`/polls/results/${ev.Id}`}>{ev.Title}</Link>
              ) : (
                ev.Title
              )}
            </td>
            <td>{moment.utc(ev.StartTime).local().format('D MMM YYYY h:mma')}</td>
            <td>{moment.utc(ev.EndTime).local().format('D MMM YYYY h:mma')}</td>
            <td>{ev.AudienceCount}</td>
            <td>{ev.ResponseCount}</td>
            <td className="table-options">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {validateAccess(this.props.auth.site, 'polls', this.props.auth) && (
                  <Link to={`/polls/poll?template=${ev.Id}`}>
                    <FontAwesome
                      style={{
                        fontSize: 20,
                        padding: 5,
                        marginLeft: 12,
                        cursor: 'pointer',
                      }}
                      name="copy"
                    />
                  </Link>
                )}
                {(validateAccess(this.props.auth.site, 'polls', this.props.auth) || ev.ShowResults) && (
                  <Link to={`/polls/results/${ev.Id}`}>
                    <FontAwesome style={{ fontSize: 20, padding: 5, marginLeft: 8 }} name="bar-chart" />
                  </Link>
                )}
                {validateAccess(this.props.auth.site, 'polls', this.props.auth) && (
                  <Link to={`/polls/poll/${ev.Id}`}>
                    <FontAwesome
                      style={{
                        fontSize: 20,
                        padding: 5,
                        marginLeft: 12,
                        cursor: 'pointer',
                      }}
                      name="pencil"
                    />
                  </Link>
                )}
                {validateAccess(this.props.auth.site, 'polls', this.props.auth) && (
                  <a
                    onClick={() => {
                      this.removePoll(ev);
                    }}
                  >
                    <FontAwesome style={{ fontSize: 20, padding: 5, marginLeft: 8, cursor: 'pointer' }} name="minus-circle" />
                  </a>
                )}
              </div>
            </td>
          </tr>
        );
      }
      return null;
    });
  }

  renderSort(col) {
    if (col !== this.state.sortColumn) {
      return null;
    }
    return <FontAwesome style={{ marginLeft: 5 }} name={this.state.sortDesc ? 'chevron-up' : 'chevron-down'} />;
  }

  sortIsActive(col) {
    if (col !== this.state.sortColumn) {
      return '';
    }
    return ' table--columnActive';
  }

  renderView(source) {
    return (
      <Table className="plussTable" striped bordered condensed hover>
        <thead>
          <tr>
            <th
              className={`${this.sortIsActive('Title')}`}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.sortByCol('Title');
              }}
            >
              Title{this.renderSort('Title')}
            </th>
            {this.props.filterOptions !== 'livePolls' && (
              <th
                className={`${this.sortIsActive('StartTime')}`}
                style={{ cursor: 'pointer', width: 120 }}
                onClick={() => {
                  this.sortByCol('StartTime');
                }}
              >
                Start time{this.renderSort('StartTime')}
              </th>
            )}
            {this.props.filterOptions !== 'livePolls' && (
              <th
                className={`${this.sortIsActive('EndTime')}`}
                style={{ cursor: 'pointer', width: 120 }}
                onClick={() => {
                  this.sortByCol('EndTime');
                }}
              >
                End time{this.renderSort('EndTime')}
              </th>
            )}
            {this.props.filterOptions === 'livePolls' && (
              <th
                className={`${this.sortIsActive('LivePollActive')}`}
                style={{ cursor: 'pointer', width: 120 }}
                onClick={() => {
                  this.sortByCol('LivePollActive');
                }}
              >
                Status{this.renderSort('LivePollActive')}
              </th>
            )}
            <th style={{ width: 140 }}>Participants</th>
            <th style={{ width: 140 }}>Responses</th>
            <th style={{ width: 70 }} />
          </tr>
        </thead>
        <tbody>{this.renderPoll(source)}</tbody>
      </Table>
    );
  }

  renderEmpty() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', alignItems: 'center', marginTop: 32 }}>
        <div className="emptyState" />
        <div className="marginTop-32" style={{ maxWidth: 500, textAlign: 'center' }}>
          <Text type="h3">There are no surveys</Text>
        </div>
      </div>
    );
  }

  renderContent() {
    let source = _.sortBy(this.state.polls, this.state.sortColumn);
    if (this.state.sortDesc) {
      source.reverse();
    }
    source = _.filter(source, (ev) => {
      if (!ev) {
        return false;
      }
      return true;
    });

    if (this.props.filterOption === 'current') {
      source = _.filter(source, (ev) => {
        return this.state.now > ev.StartTime && this.state.now < ev.EndTime;
      });
    } else if (this.props.filterOption === 'past') {
      source = _.filter(source, (ev) => {
        return this.state.now > ev.EndTime;
      });
    } else if (this.props.filterOption === 'livePolls') {
      source = _.filter(source, (ev) => {
        return ev.IsLivePoll;
      });
    } else {
      source = _.filter(source, (ev) => {
        return !ev.IsLivePoll;
      });
    }
    // source = []
    if (_.isEmpty(source)) {
      return this.renderEmpty();
    }
    return this.renderView(source);
  }

  render() {
    return (
      <div style={{ minWidth: '100%' }}>
        {this.renderContent()}
        {/* {this.renderView()} */}
        <div className="hub_tidioPadding"></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { polls } = state.feedback;
  const { auth } = state;
  return {
    polls,
    auth,
  };
};

export default connect(mapStateToProps, { pollsLoaded, removePoll })(ListPoll);
